import type { AuthRealm } from '~/shared-kernel/domain/auth'

const RECOVERY_TOKEN_PATTERN = /^[A-Za-z0-9_-]{43}$/

export interface PasswordRecoveryRoutes {
  forgotPassword: string
  login: string
}

export function parsePasswordRecoveryHash(hash: string): string | null {
  const token = new URLSearchParams(hash.replace(/^#/, '')).get('token') || ''
  return RECOVERY_TOKEN_PATTERN.test(token) ? token : null
}

export function getPasswordRecoveryRoutes(realm: AuthRealm): PasswordRecoveryRoutes {
  return realm === 'staff'
    ? { forgotPassword: '/staff/forgot-password', login: '/staff/login' }
    : { forgotPassword: '/account/forgot-password', login: '/account/login' }
}
